import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
const VotingModal = (props) => {
  return (
    <>
      <Modal show={props.show} onHide={() => props.setShow(false)} size="lg">
        <Modal.Header>Fixture Voting</Modal.Header>
        <Modal.Body style={{ overflowY: "auto" }}>
          <ul className="votelist">
            {props.votingList &&
              props.votingList.map((item1, key) => (
                <li key={key}>
                  <label>{item1?.name}</label>
                  <div className="customselect">
                    <select
                      className="form-control threevote"
                      onChange={(e) =>
                        props.handleVote(e.target.value, item1?.id, item1?.name)
                      }
                      value={props.doesCombinationExist(
                        props.fixture_id,
                        item1?.id
                      )}
                    >
                      <option>Please Select Player</option>
                      {props.playerListing &&
                        props.playerListing.map((item, key) => (
                          <option value={item?.player_id} key={key}>
                            {item?.full_name}
                          </option>
                        ))}
                    </select>
                  </div>
                </li>
              ))}
          </ul>
          <table className="main-table4 table innertable">
            <thead>
              <tr>
                <th>Top 5 Players</th>
                <th>R</th>
                <th>WK</th>
                <th>FPS</th>
              </tr>
            </thead>
            <tbody>
              {props.topFivePlayer.length > 0 &&
                props.topFivePlayer.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <Link to={`/player-profile/${item.player_id}`}>
                        {item.full_name}
                      </Link>
                    </td>
                    <td>{item.rs ? item.rs : 0}</td>
                    <td>{item.wks ? item.wks : 0}</td>
                    <td>{item.fantasy_points}</td>
                  </tr>
                ))}
              {props.topFivePlayer.length === 0 && (
                <tr>
                  <td colSpan={16}>No record yet available.</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link className="border-btn" onClick={() => props.setShow(false)}>
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VotingModal;
